import { Typography } from "@mui/material";
import moment from "moment";

export const HeaderConfig = [
  {
    label: "Ticket ID",
    id: "ticketId",
    onClick: true,
    render: (data, onClick) => {
      return (
        <span className="clickable" onClick={() => onClick(data)}>
          {data.ticketId}
        </span>
      );
    },
  },
  {
    label: "Created On",
    id: "createdAt",
    render: (data) => {
      return (
        <span>
          {data.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}{" "}
        </span>
      );
    },
  },
  {
    label: "Transporter",
    id: "transporter",
  },
  {
    label: "Stock Engine Physical Status",
    id: "stoackEnginePhysicalStatus",
  },
  {
    label: "Status",
    id: "status",
  },
  {
    label: "Reference No.",
    id: "referenceNumber",
  },
  {
    label: "List No.",
    id: "listNumber",
  },
  {
    label: "Engine Type",
    id: "engineType",
  },
  {
    label: "Docket Number",
    id: "docketNumber",
  },
];
